import { Component, Input, OnInit } from '@angular/core';
import { ChartConfigService } from 'src/app/utils/chart/chart-config.service';
import { VehiculeClassification } from '../../activity-vehicule-classifications.model';
const Highcharts = require('highcharts');
require('highcharts/modules/exporting')(Highcharts);

@Component({
  selector: 'app-classification-speed-carto-chart',
  templateUrl: './classification-speed-carto-chart.component.html',
  styleUrls: ['./classification-speed-carto-chart.component.css']
})
export class ClassificationSpeedCartoChartComponent implements OnInit {

  classmentObject: Object | null = null;
  speedCartoClassments: VehiculeClassification[] = [];


  @Input()
  set speeding(speeding: VehiculeClassification[]) {
    if (speeding) {
      this.speedCartoClassments = Object.assign(speeding);
      this.speedCartoChart();
    }
  }

  constructor(private chartConfig : ChartConfigService) { }

  ngOnInit() {
    this.speedCartoChart();
  }

  speedCartoChart() {
    this.chartConfig.setHighCartsLang();
    var seriesData = [];

    for (let classment of this.speedCartoClassments.filter(c => c.total > 0)) {
      seriesData.push([classment.matricule, classment.total])
    }

    this.classmentObject = {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Excés vitesse',
        align: 'center',
        style: {
          fontWeight: 'bold'
        }
      },
      xAxis: {
        type: 'category',

        labels: {
          rotation: -45,
          style: {
            color: "#000000",
            fontWeight: 'bold',
            textDecoration: "underline"
          }
        }
      },
      yAxis: {
        title: {
          text: 'Nbr'
        },
        labels: {
          enabled: false
        }
      },
      legend: {
        enabled: false
      },
      accessibility: {
        point: {
          valueSuffix: 'Nbr'
        }
      }, credits: {
        enabled: false
      },
      tooltip: {
        pointFormat: '<b>{point.y}</b>'
      },
      plotOptions: {
        column: {
          borderRadius: 5
        },
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: false,
            format: '{point.y} '
          }
        }
      },
      series: [{
        colorByPoint: true,
        data: seriesData
      }]
    }
    Highcharts.chart('classmentSpeedCartoObject', this.classmentObject);
  }


}
